<div class="empty-state">
  <!-- QA #602 F-3: decorative illustration, hidden from assistive tech via
       ng-svg-icon-sprite's own attribute passthrough (sets aria-hidden="true"
       on the rendered <svg>) rather than an app.scss/[attr.*] workaround. -->
  <svg-icon-sprite
    width="500px"
    preserveAspectRatio="false"
    [src]="icon"
    [attribute]="['aria-hidden', 'true']"
  >
  </svg-icon-sprite>
  <div>
    <h3>{{ heading }}</h3>
    <label *ngIf="subtext">{{ subtext }}</label>
  </div>
</div>
